import type { ProductTaxonomyRenameDefinition } from '../types';

export const automationsRename = {
  terms: {
    campaigns: {
      current: {
        singular: 'campaign',
        plural: 'campaigns',
        titleSingular: 'Campaign',
        titlePlural: 'Campaigns',
      },
      future: {
        singular: 'automation',
        plural: 'automations',
        titleSingular: 'Automation',
        titlePlural: 'Automations',
      },
    },
  },
  copy: {
    'nav.sendMessages.campaigns': {
      term: 'campaigns.titlePlural',
    },
    'home.startCampaignCard': {
      current: 'Start a campaign',
      future: 'Start an automation',
    },
    'home.launchedCampaignFallback': {
      current: 'a campaign',
      future: 'an automation',
    },
  },
  routes: {
    'campaigns.index': {
      current: '/workspaces/:workspaceId/journeys/campaigns',
      future: '/workspaces/:workspaceId/journeys/automations',
    },
  },
  sideNavItemIds: {
    campaigns: 'automations',
  },
} as const satisfies ProductTaxonomyRenameDefinition;
